import { type ReactNode } from 'react';
import { Outlet } from 'react-router';

import Footer from './Footer';
import GridOverlay from './GridOverlay';
import Header from './Header';

interface LayoutProps {
  children?: ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  return (
    <div className="bg-primary flex min-h-screen flex-col">
      <GridOverlay />
      <Header />
      <main className="flex-1">{children ?? <Outlet />}</main>
      <Footer />
    </div>
  );
}
